export default function registerLoginScreen(Alpine) {
    Alpine.data('loginScreen', () => ({
        screen: 'login',
        showPassword: false,
        identity: '',
        password: '',
        sessionMessage: null,
        identityError: null,
        passwordError: null,

        init() {
            const el = document.getElementById('login-server-data')
            if (el) {
                const data = JSON.parse(el.textContent)
                this.sessionMessage = data.sessionMessage || null
                this.identityError = data.identityError || null
                this.passwordError = data.passwordError || null
                this.identity = data.identity || ''
            }
        },

        handleSubmit() {
            const timezoneInput = document.getElementById('timezone')
            if (timezoneInput) {
                try {
                    timezoneInput.value =
                        Intl.DateTimeFormat().resolvedOptions().timeZone ?? ''
                } catch {
                    timezoneInput.value = ''
                }
            }
        },
    }));
}
